var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20749_147653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.81998 0.480469C2.6992 0.480469 0.97998 2.19969 0.97998 4.32047V19.6805C0.97998 21.8012 2.6992 23.5205 4.81998 23.5205H20.18C22.3008 23.5205 24.02 21.8012 24.02 19.6805V4.32047C24.02 2.19969 22.3008 0.480469 20.18 0.480469H4.81998ZM5.96427 5.41761H10.3186L13.4107 9.81154L17.1628 5.41761H18.5343L14.03 10.6912L19.5843 18.5833H15.2311L11.6428 13.4855L7.28855 18.5833H5.91712L11.0236 12.6058L5.96427 5.41761ZM8.06427 6.51475L15.8032 17.4862H17.4843L9.74534 6.51475H8.06427Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20749_147653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterx);
export default __webpack_public_path__ + "static/media/twitterx.e0cebd984db250cb8ff362c6f8b5f167.svg";
export { ForwardRef as ReactComponent };